import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import convert from '../../helpers/convert'
import format from '../../helpers/format'
import { asyncConnect } from 'redux-async-connect'
import container from '../../helpers/container'
import analytics from '../../helpers/analytics'
import { SlideDown } from 'react-slidedown'
import { Row, Col } from 'react-flexbox-grid'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  BenchmarkChart,
  PortfolioContributors,
  FundMenu,
  FundName,
  FundShareTakeAction,
  XsBr,
  IyvScorecard,
  FootprintDeprecated,
  // AssetManagerLetter
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './FundCarbonFootprint.css'

@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  }),
  searchActions)

@asyncConnect([{
  deferred: true, // need otherwise cient navigate blocked until page loaded
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(searchActions.shareClassDetails(params.fundId,
                                                    params.investmentVehicleId))
  }
}])

@CSSModules(Styles, {allowMultiple:true})
export default class FundCarbonFootprint extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      viewMoreRelativeCarbonFootprint: false,
      viewMoreRelativeCarbonIntensity: false,
      viewMoreEmissionsScope1_2: false,
      viewMoreEmissionsScope3: false,
      viewMoreCoverageDisclosingTitles: false,
      viewMoreCoverageMarketValue: false
    }
  }

  componentWillMount(){
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  componentDidMount(){
    // window.addEventListener('scroll', this.handleScroll)
    analytics.event(analytics.eventLoadFund(this.props.params.fundId, this.props.params.investmentVehicleId))
  }

  // handleScroll = () => {
  //   if( !this.props.result ){ return }
  // }

  // need this solution since asyncConnect and anchor links does not play nice
  scrollTo = (id) => {
    return () =>{
      const ele = document.getElementById(id)
      window.scrollTo(ele.offsetLeft,ele.offsetTop)
    }
  }

  clickViewMoreRelativeCarbonFootprint = () => {
    this.setState({
      viewMoreRelativeCarbonFootprint: !this.state.viewMoreRelativeCarbonFootprint
    })
  }
  clickViewMoreRelativeCarbonIntensity = () => {
    this.setState({
      viewMoreRelativeCarbonIntensity: !this.state.viewMoreRelativeCarbonIntensity
    })
  }
  clickViewMoreEmissionsScope1_2 = () => {
    this.setState({
      viewMoreEmissionsScope1_2: !this.state.viewMoreEmissionsScope1_2
    })
  }
  clickViewMoreEmissionsScope3 = () => {
    this.setState({
      viewMoreEmissionsScope3: !this.state.viewMoreEmissionsScope3
    })
  }
  clickViewMoreCoverageDisclosingTitles = () => {
    this.setState({
      viewMoreCoverageDisclosingTitles: !this.state.viewMoreCoverageDisclosingTitles
    })
  }
  clickViewMoreCoverageMarketValue = () => {
    this.setState({
      viewMoreCoverageMarketValue: !this.state.viewMoreCoverageMarketValue
    })
  }

  renderFootprintTable = (fund) => {
    // each fund has a benchmark comparison calculated by the yoursri API
    const benchmarkExists = (fund.benchmarks && fund.benchmarks.length>0)
    const benchmark = benchmarkExists ? fund.benchmarks[0] : {}

    return (
      <div styleName="foot-table">
        <div styleName="foot-table-inner">
          <Row styleName='foot-table-header'>
            <Col xs={4}/>
            <Col xs={4} styleName='foot-table-row-header'>
              {fund.fund_legal_name}
            </Col>
            <Col xs={4} styleName='foot-table-row-header'>
              Benchmark: MSCI ACWI<sup>*</sup>
            </Col>
          </Row>

          <Row
            styleName={(this.state.viewMoreEmissionsScope1_2)?'foot-table-row-active':'foot-table-row'}
            onClick={this.clickViewMoreEmissionsScope1_2}
            title='View more'>
            <Col xs={4}>
              <LinkIcon faclass='fa-info-circle' nowrap={true}/>&nbsp;&nbsp;
              { (this.state.viewMoreEmissionsScope1_2)
                ? (<LinkIcon faclass='fa-caret-down'/>)
                : (<LinkIcon faclass='fa-caret-right'/>) }
              <XsBr /> <b>Emissions scope 1+2</b><XsBr /> tCO2e
            </Col>
            <Col xs={4} styleName='foot-table-row-number'>
              {format.number(fund.portfolio_carbon_total_emissions_1_2,true,true)}
            </Col>
            <Col xs={4} styleName='foot-table-row-number'>
              {format.number(benchmark.carbon_total_emissions_1_2,true,true)}
            </Col>
          </Row>

          <SlideDown>
            { (this.state.viewMoreEmissionsScope1_2)?(
                <Row styleName='foot-table-info-row'>
                  <Col xs={12}>
                    <div styleName='foot-table-info-row-flex'>
                      <div styleName='foot-table-info-row-flex-info'>
                        <strong>Emissions scope 1+2:</strong> Measures the absolute greenhouse gas footprint of a portfolio in tons of carbon dioxide equivalents (tCO2e). This measures the total annualized greenhouse gas emissions for which an equity portfolio is responsible, based on the 'ownership principle'. This is done by summing up the proportionate carbon emissions of companies in the portfolio based on the investor's ownership share.
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : null }
          </SlideDown>

          <Row
            styleName={(this.state.viewMoreEmissionsScope3)?'foot-table-row-active':'foot-table-row'}
            onClick={this.clickViewMoreEmissionsScope3}
            title='View more'>
            <Col xs={4}>
              <LinkIcon faclass='fa-info-circle' nowrap={true}/>&nbsp;&nbsp;
              { (this.state.viewMoreEmissionsScope3)
                ? (<LinkIcon faclass='fa-caret-down'/>)
                : (<LinkIcon faclass='fa-caret-right'/>) }
              <XsBr /> <b>Emissions scope 1+2+3</b><XsBr /> tCO2e
            </Col>
            <Col xs={4} styleName='foot-table-row-number'>
              {format.number(fund.portfolio_carbon_total_emissions_3,true,true)}
            </Col>
            <Col xs={4} styleName='foot-table-row-number'>
              {format.number(benchmark.carbon_total_emissions_3,true,true)}
            </Col>
          </Row>

          <SlideDown>
            { (this.state.viewMoreEmissionsScope3)?(
                <Row styleName='foot-table-info-row'>
                  <Col xs={12}>
                    <div styleName='foot-table-info-row-flex'>
                      <div styleName='foot-table-info-row-flex-info'>
                        <strong>Emissions scope 1+2+3:</strong> The footprint analysis is based on direct and indirect company emissions (Scope 1 and Scope 2). Scope 3 emissions are only being reported in this specific subsection and on an industry level as currently the definition and the measurement and disclosure is not consistently applied by companies.
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : null }
          </SlideDown>

          <Row
            styleName={(this.state.viewMoreCoverageDisclosingTitles)?'foot-table-row-active':'foot-table-row'}
            onClick={this.clickViewMoreCoverageDisclosingTitles}
            title='View more'>
            <Col xs={4}>
              <LinkIcon faclass='fa-info-circle' nowrap={true}/>&nbsp;&nbsp;
              { (this.state.viewMoreCoverageDisclosingTitles)
                ? (<LinkIcon faclass='fa-caret-down'/>)
                : (<LinkIcon faclass='fa-caret-right'/>) }
              <XsBr /> <b>Coverage</b><XsBr /> by # of disclosing titles
            </Col>
            <Col xs={4} styleName='foot-table-row-number'>
              {format.perc(fund.portfolio_coverage_disclosing_titles / 100)}
            </Col>
            <Col xs={4} styleName='foot-table-row-number'>
              {format.perc(benchmark.coverage_disclosing_titles / 100)}
            </Col>
          </Row>

          <SlideDown>
            { (this.state.viewMoreCoverageDisclosingTitles)?(
                <Row styleName='foot-table-info-row'>
                  <Col xs={12}>
                    <div styleName='foot-table-info-row-flex'>
                      <div styleName='foot-table-info-row-flex-info'>
                        <strong>Coverage by # of disclosing titles:</strong> All footprint data is based on South Pole Group's database for greenhouse gas emissions of about 40,000 companies. Emissions data is based on disclosed sources, including documents such as company CSR reports, company websites, and non-governmental and regulatory databases, as well as approximations. In cases where the company does not disclose any carbon data or the reported data has been classified as not trustworthy, a carbon estimation methodology is applied. Coverage is measured as a percentage, of both number of disclosing titles and market value weight.
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : null }
          </SlideDown>

          <Row
            styleName={(this.state.viewMoreCoverageMarketValue)?'foot-table-row-active':'foot-table-row'}
            onClick={this.clickViewMoreCoverageMarketValue}
            title='View more'>
            <Col xs={4}>
              <LinkIcon faclass='fa-info-circle' nowrap={true}/>&nbsp;&nbsp;
              { (this.state.viewMoreCoverageMarketValue)
                ? (<LinkIcon faclass='fa-caret-down'/>)
                : (<LinkIcon faclass='fa-caret-right'/>) }
              <XsBr /> <b>Coverage</b><XsBr /> by market value weight
            </Col>
            <Col xs={4} styleName='foot-table-row-number'>
              {format.perc(fund.portfolio_coverage_by_weight / 100)}
            </Col>
            <Col xs={4} styleName='foot-table-row-number'>
              {format.perc(benchmark.coverage_by_weight / 100)}
            </Col>
          </Row>

          <SlideDown>
            { (this.state.viewMoreCoverageMarketValue)?(
                <Row styleName='foot-table-info-row'>
                  <Col xs={12}>
                    <div styleName='foot-table-info-row-flex'>
                      <div styleName='foot-table-info-row-flex-info'>
                        <strong>Coverage by market value weight:</strong> All footprint data is based on South Pole Group's database for greenhouse gas emissions of about 40,000 companies. Emissions data is based on disclosed sources, including documents such as company CSR reports, company websites, and non-governmental and regulatory databases, as well as approximations. In cases where the company does not disclose any carbon data or the reported data has been classified as not trustworthy, a carbon estimation methodology is applied. Coverage is measured as a percentage, of both number of disclosing titles and market value weight.
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : null }
          </SlideDown>

          <div styleName='foot-table-disclaimer'>
            * Full emissions and coverage data for MSCI ACWI index provided by yourSRI
          </div>
        </div>
      </div>
    )
  }

  renderFootprintResults = (fund) => {
    const yoursriIcon = require( '../../../static/images/yoursri-logo.png' )
    return (
      <div styleName='main'>
        <BenchmarkChart fund={fund}/>
        <div styleName='yoursri-container'>
          <div styleName='yoursri-container-inner'>
            <div styleName='yoursri-box'>
              <div styleName='yoursri-info'>
                Carbon footprint profile is provided by <Link to={config.links.yoursri} title='yourSRI.com' xstrong><b>yourSRI</b></Link>.
                Metrics like carbon footprint and carbon intensity are calculated
                by tracking and measuring the greenhouse gas emissions of the
                underlying companies owned by the fund.
                <br/>
                <br/>
                <Link to={config.links.yoursri} title='yourSRI.com' xstrong><b>Find more carbon footprint information about this fund at yourSRI.</b></Link>
              </div>
              <div styleName='yoursri-icon-wrap'>
                <Link to={config.links.yoursri} title='yourSRI.com'>
                  <img styleName='yoursri-icon' alt='yourSRI.com'
                    src={yoursriIcon} />
                </Link>
              </div>
            </div>
          </div>
        </div>
        { this.renderFootprintTable(fund) }
        <PortfolioContributors fund={fund}/>
      </div>
    )
  }

  renderSorryNoData = () => {
    return (
      <div styleName='main'>
        <div styleName='sorry-container'>
          <div styleName='sorry-container-inner'>
            <div styleName='sorry-headline'>
              Sorry, we don't have a carbon footprint for this fund.
            </div>
          </div>
        </div>
      </div>
    )
  }

  render(){
    // loading icons
    if (!this.props.result) {
      return (
        <div styleName="main">
          <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={false} />
        </div>
      )
    } else if (this.props.result && (!this.props.result.fund || !this.props.result.shareClass)) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={false} />
        </div>
      )
    }

    const { fund, shareClass } = this.props.result
    // const { holdings, fundholdings } = fund
    const title = shareClass.fund_legal_name + ' | Carbon footprint'
    const url = config.domain + this.props.location.pathname

    const _ticker = shareClass.ticker || null
    let fundName = `${fund.fund_legal_name}`
    fundName = _ticker ? `${fundName} ${_ticker}` : fundName
    const description = `${fundName} has a carbon footprint of ${format.number(convert.float(fund.usd_relative_footprint))} tonnes CO2 / $1M USD invested`

    return (
      <div>
        {container.helmet(title, description, url)}

        <br/>
        <FundMenu
          active='Carbon footprint'
          fundId={shareClass.fund_id}
          investmentVehicleId={shareClass.investment_vehicle_id}
          name={shareClass.fund_legal_name}
          ticker={shareClass.ticker}
        />

        <FundName
          shareClass={shareClass}
          pathname={this.props.location.pathname}
        />

        { /* temporary asset manager letter for Vanguard */ }
        { /* <AssetManagerLetter fundFamilyName={fund.fund_family_name}/> */ }

        <ContainerDivs>
          <FootprintDeprecated />
        </ContainerDivs>

        <div styleName='fossil-fuel-banner-wrap'>
          <ContainerDivs>
            <h2 styleName='fossil-fuel-banner-hl'>
              <span styleName='fossil-fuel-banner-hl-lg'>Carbon footprint</span>
              <span styleName='fossil-fuel-banner-hl-sm'>of all the companies in the portfolio.</span>
            </h2>
          </ContainerDivs>
        </div>

        {
          (
            fund.usd_relative_footprint &&
            convert.float(fund.usd_relative_footprint) !== 0.0
          ) ?
            this.renderFootprintResults(fund) :
            this.renderSorryNoData()
          }

        { /*
        <FundNext
          prev='fossil-fuel-investments'
          prevLabel='Fossil fuels'
          next='clean200-investments'
          nextLabel='Clean200'
          ticker={shareClass.ticker}
          name={shareClass.fund_legal_name}
          investmentVehicleId={shareClass.investment_vehicle_id}
          fundId={shareClass.fund_id}
        />
        */ }

        <IyvScorecard
          fund={fund}
          shareClass={shareClass}
        />

        { /* 
        <FundShareTakeAction shareClass={shareClass} url={url} />
        */ }

      </div>
    )
  }
}

